
import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';

import { SignupFlowContext } from './signup-flow-provider';

export function useLogEnteredPage({
  Flow,
  Page,
}) {
  const { enteredPage } = useContext(SignupFlowContext);
  useEffect(() => {
    if (Page) {
      enteredPage({ Flow, Page });
    }
  }, [Flow, Page, enteredPage]);
}
export function LogEnteredPageOnRender({
  Flow,
  Page,
}) {
  useLogEnteredPage({ Flow, Page });
  return (<></>);
}

LogEnteredPageOnRender.propTypes = {
  Flow: PropTypes.string.isRequired,
  Page: PropTypes.string,
};

LogEnteredPageOnRender.defaultProps = {
  Page: null,
};

export function LogEnteredPageOnStep({
  StepsContext,
  Flow,
  PathToPage,
}) {
  const { currentPath } = useContext(StepsContext);
  const Page = currentPath && PathToPage ?
    PathToPage[currentPath] :
    currentPath;

  useLogEnteredPage({ Flow, Page });
  return <></>;
}

LogEnteredPageOnStep.propTypes = {
  StepsContext: PropTypes.shape({}).isRequired,
  PathToPage: PropTypes.shape({}),
  Flow: PropTypes.string.isRequired,
};

LogEnteredPageOnStep.defaultProps = {
  PathToPage: null,
};
